module.exports = __webpack_public_path__ + "img/sb.947a3c13.svg";